// src/api/config.js
// 后端接口基础地址：默认指向生产域名 www.meijiematou.com
export const BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://www.meijiematou.com/api'